const preventScrollEvent = (event) => {
  event.preventDefault()
}

/** 关闭屏幕滑动 */
export const scrollClose = () => {
  document.body.addEventListener('touchmove', preventScrollEvent, { passive: false })
}
/** 开启屏幕滑动 */
export const scrollOpen = () => {
  document.body.removeEventListener('touchmove', preventScrollEvent)
}

/**
 * 是否终身会员，服务端不提供该标示，已反馈过了
 * 特殊处理：判断终身会员，目前会员没有字段表示终身会员，目前使用有效期来判断
 * 依据可牛最新协议，终身会员并非真正终身，有效期为27年左右，由于无法获取到会员购买的日期，最早一批可牛用户是2021购买会员
 * 直接使用2040年作为判断年限
*/
export const isVipForever = (privliegeEndTime) => {
  if (!privliegeEndTime || typeof privliegeEndTime !== 'string') {
    return false
  }

  if (privliegeEndTime) {
    const [strYear] = privliegeEndTime.split('-')
    const yearForever = 2040
    if (Number(strYear) >= yearForever) {
      return true
    }
  }
  return false
}
